var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FCEDE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3327 20.5466L35.4527 18.6666L27.9993 26.12L20.546 18.6666L18.666 20.5466L26.1193 28L18.666 35.4533L20.546 37.3333L27.9993 29.88L35.4527 37.3333L37.3327 35.4533L29.8793 28L37.3327 20.5466Z",
    fill: "#E74141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceled);
export default __webpack_public_path__ + "static/media/canceled.0cd369df9d9578deb955669b60199d91.svg";
export { ForwardRef as ReactComponent };